import dynamic from 'next/dynamic'
import { ErrorBoundary } from '../src/components/ErrorBoundary'

const PrivacyPolicy = dynamic(() => import('../src/pages/PrivacyPolicy'), {
  ssr: false,
})

export default function Privacy() {
  return (
    <ErrorBoundary>
      <PrivacyPolicy />
    </ErrorBoundary>
  )
}